const baseTemplate = {
  plan: 'The identifier of the plan to add to the subscription::String',
  subscription: 'The identifier of the subscription to modify::String',
  quantity: 'The quantity you’d like to apply to the subscription item you’re creating.::Number',
}

export default baseTemplate
